<template lang="pug">
    .stock-index-list.box
        .stock-item(v-for="item in mixinItems" :key="item.code" :label="item.name" :name="item.code")
            p {{item.name}} ({{item.code.replace(/[a-zA-Z]+/, '')}})
            h3
                strong(:class="item.latest_price - item.close_price >= 0 ? 'red' : 'green'") {{(item.latest_price).toFixed(2)}}
            p
                span(:class="item.latest_price - item.close_price >= 0 ? 'red' : 'green'") 涨跌幅：{{(item.latest_price - item.close_price).toFixed(2)}}
                    | ({{((item.latest_price - item.close_price) / item.close_price * 100).toFixed(2)}}%)
            p
                span 昨日收盘价：{{(item.close_price).toFixed(2)}}
            p {{item.date}} {{item.time}}


            StockTimeline(:code="item.code")
</template>

<script>
import listMixin from './list-mixin.vue';
import StockTimeline from './stock-timeline.vue';
import intervalMixin from './interval-mixin.vue';

export default {
    name: 'StockIndex',
    mixins: [listMixin, intervalMixin],
    components: { StockTimeline },
    data() {
        return {
            mixinUrl: 'v2/finance/index/list',
        };
    },
    created() {},
    methods: {
        handleClick({ name }) {},
        mixinIntervalMethods() {
            this.mixinGetList();
        },
    },
};
</script>

<style lang="stylus" scoped>
h3
    font-size 3em
.stock-index-list
    width 100%
    display flex
    justify-content space-between
    box-sizing border-box
.stock-item
    width 30%
</style>
